import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastrService } from '@shared/services/toastr.service';
import { AdminService } from '@shared/services/admin.service';
import { AdminUserService, User } from '@shared/services/admin-user.service';
import { distinctUntilChanged, fromEvent, Subject, switchMap } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TimestampCellComponent } from '@shared/components/timestamp-cell/timestamp-cell.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalBasicComponent } from '@shared/components/modal-basic/modal-basic.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  imports: [
    NgFor,
    NgClass,
    RouterLink,
    TimestampCellComponent,
    NgIf,
    NgxPaginationModule,
    ModalBasicComponent,
    TranslatePipe,
  ],
})
export class UsersComponent implements AfterViewInit {
  lang: string;

  page = 0;
  pageSize = 20;
  totalItems: number;
  users: User[] = [];
  @ViewChild('remove') removePopup: any;
  @ViewChild('search') search: ElementRef;
  user: User;

  triggerLoadPage = new Subject<void>();

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private adminUserService: AdminUserService,
    public admin: AdminService,
  ) {}

  ngAfterViewInit(): void {
    this.triggerLoadPage.pipe(switchMap(() => this.getUsers())).subscribe((page) => {
      this.totalItems = page.totalElements;
      this.users = page.content;
    });

    fromEvent(this.search.nativeElement, 'keyup')
      .pipe(
        debounceTime(300),
        map(() => this.search.nativeElement.value as string),
        distinctUntilChanged(),
      )
      .subscribe(() => this.newSearch());

    this.loadPage();
  }

  newSearch() {
    this.page = 0;
    this.loadPage();
  }

  loadPage() {
    this.triggerLoadPage.next();
  }

  modalRemove(p: any) {
    this.removePopup.show();
    this.user = { ...p };
  }

  changePage(pageNumber: number) {
    this.page = pageNumber - 1;
    this.loadPage();
  }

  getUsers() {
    return this.adminUserService.loadUsersPaginated(
      this.search.nativeElement.value as string,
      this.page,
      this.pageSize,
    );
  }

  removeUser() {
    this.http.delete('admin/users/' + this.user.id).subscribe((_: any) => {
      this.toastr.success('SuppressionSucces');
      this.user = undefined;
      this.removePopup.hide();
      this.loadPage();
    });
  }

  resendRegistrationMail(user: User) {
    this.adminUserService.resendRegistrationMail(user.email).subscribe((res) => {
      if (res.hasError) {
        this.toastr.error();
      } else {
        this.toastr.success();
      }
    });
  }
}
